<template>
  <div>
    <v-switch
      :disabled="loading || disabled"
      :loading="loading"
      :color="type == 'active' ? '#26BE00' : '#ed143d'"
      v-model="item[value == 'update-active' ? 'is_admin_active_user' : value]"
      @mousedown="confirmSwith(item, value, $event)"
    ></v-switch>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      required: false,
    },
    name: {
      required: true,
    },
    value: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
    };
  },
  methods: {
    // ===== Delete
    confirmSwith(item, value, event) {
      event.preventDefault();
      // Start:: Sweet Alert  Modal
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("youWillNotBeAbleToGoBackInTheProcess"),

        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("cancel"),
        confirmButtonText: this.$t("confirm"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.SwitchToggle(item, value);
        }
      });
      // End:: Sweet Alert  Modal
    },

    SwitchToggle(item, value) {
      this.loading = true;
      let frmData = new FormData();
      if (value == "is_active" || value == "is_admin_active_user") {
        frmData.append("_method", "PATCH");
      } else {
        frmData.append("_method", "PUT");
      }
      // is_admin_active_user

      frmData.append(
        value == "is_admin_active_user" ? "is_active" : value,
        +item[value] == 0 ? 1 : 0
      );

      let url = "";
      let message = "";

      if (value == "is_locked") {
        url = `${this.name}/${item.id}/update-locked`;
        message = item.is_locked == 1 ? "Account blocked" : "Account unblocked";
      } else if (value == "is_active" && this.name == "stadiums") {
        frmData = new FormData();
        url = `${this.name}/${item.id}/toggle-active-stadium`;
        message = item.is_active
          ? this.$t("stadium_activated")
          : this.$t("stadium_deactivated ");
      } else if (value == "is_active" && this.name != "groups") {
        url = `${this.name}/${item.id}/toggle-active-user`;
        message = item.is_active ? "User activated" : "User deactivated";
      } else if (value == "is_active" && this.name == "groups") {
        url = `${this.name}/${item.id}/toggle-active`;
        message = item.is_active ? "Group activated" : "Group deactivated";
      } else if (value == "is_ban") {
        url = `${this.name}/${item.id}/update-ban`;
        message = item.is_ban == 1 ? "Account unblocked" : "Account blocked";
      } else if (value == "is_admin_active_user") {
        url = `${this.name}/${item.id}/toggle-active-user`;
        message = item.is_admin_active_user
          ? "Account deactivated"
          : "Account activated";
      } else if (value == "update-active") {
        url = `${this.name}/${item.id}/update-active`;
        message = item.is_admin_active_user
          ? "Account deactivated"
          : "Account activated";
      }
      // else if (value == "toggle_discount") {
      //   console.log("this.$route.params", this.$route.params);
      //   url = `players/${this.$route.params.PlayerId}/groups/${this.$route.params.id}/${this.name}/${item.id}/toggle`;
      //   message = item.is_active ? "تم  الغاء تفعيل الخصم" : "تم  تفعيل الخصم";
      // }

      this.axios
        .post(url, frmData)
        .then(() => {
          item[value == "update-active" ? "is_admin_active_user" : value] =
            +item[value == "update-active" ? "is_admin_active_user" : value] ==
            1
              ? 0
              : 1;
          this.loading = false;
          this.$iziToast.success({
            title: this.$t("success"),
            message: message,
          });
          // this.$router.go(0);
        })
        .catch((err) => {
          this.loading = false;
          this.$iziToast.error({
            title: this.$t("error"),
            message: err.response?.data.message ?? err.response?.data.messages,
          });
        });
    },
  },
};
</script>

<style></style>
